import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { FaFileExport } from "react-icons/fa";
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ZoneLocations = () => {
    const [locations, setLocations] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState('')
    const gridRef = useRef();

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state) {
            const {payload} = location.state
            fetchData(payload)
            setTitle(`${payload.name} ${payload?.status ? payload.status : "Active & Inactive"} Locations`)
        }
    }, [])

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            sortable: true,
            width: 100,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "ID",
            field: "location_id",
            sortable: true,
            width: 100,
            filter: true
        },
        {
            headerName: "Name",
            field: "full_name",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Station",
            field: "station_name",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Line",
            field: "line_name",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Rate",
            field: "rate_name",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "MeterID",
            field: "serial_number",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "LockID",
            field: "lock_number",
            sortable: true,
            width: 100,
            filter: true,
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            width: 100,
            filter: 'agNumberColumnFilter',
        },
    ]);

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/zones/${payload.public_id}/locations/?${payload?.status ? `_status=${payload.status}` : ""}`)
            setLocations(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to fetch zone locations')
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            rowData={locations}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            enableCellTextSelection={true}

                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}

                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
        </div>
    </div>
    </>
  )
}

export default ZoneLocations